module.exports = __webpack_public_path__ + "static/media/angular2.2c00262f.png";